import { PanelLeft } from "lucide-react";
import React, { FC } from "react";

import { IgIconButton, IgTooltip } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { useDispatch } from "@src/store";
import { setSideNavCollapsed } from "@src/store/slices/appSettings";

export const SideNavCollapseControl = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Grid item>
      <IgTooltip title={"Collapse Navigation"}>
        <IgIconButton
          onClick={() => {
            dispatch(setSideNavCollapsed());
          }}
        >
          <PanelLeft size={16} />
        </IgIconButton>
      </IgTooltip>
    </Grid>
  );
};
